import { Handle, Position } from '@xyflow/react'
import { useChatbotFlow } from '../chatbot.provider'
import { DeletingNodeButton } from './deleting-node-button.component'
import { ConnectingNodeButton } from './connecting-node-button.component'
import { AddingNodeButton } from './adding-node-button.component'
import { ChatbotNodeBooleanResponse } from './chatbot-node-boolean-response.component'
import { ChatbotNodeIntegerRangeResponse } from './chatbot-node-integer-range-response.component'
import { ChatbotNodeMediaResponse } from './chatbot-node-media-response.component'
import { TNodeVariable } from '../node.type'
import { EVariableType } from 'src/types/variable'

type TChatbotNodeResponsesProps = {
  id: string
  selected?: boolean
  isHovered?: boolean
  isFirstNode: boolean
  hasOutgoingEdge: boolean
  isSourceOfSelectedEdge?: boolean
  variable?: TNodeVariable
}

export function ChatbotNodeResponses({
  id,
  selected,
  isHovered,
  isFirstNode,
  hasOutgoingEdge,
  isSourceOfSelectedEdge,
  variable,
}: TChatbotNodeResponsesProps) {
  const { addNodeWithConnection, deleteNode } = useChatbotFlow()

  const handleAddNode = (e: React.MouseEvent) => {
    e.stopPropagation()
    addNodeWithConnection(id)
  }

  const handleDeleteNode = (e: React.MouseEvent) => {
    e.stopPropagation()
    deleteNode(id)
  }

  const showActions = !!(selected || isHovered)

  if (variable?.type === EVariableType.BOOLEAN) {
    return <ChatbotNodeBooleanResponse id={id} showActions={showActions} />
  }

  if (variable?.type === EVariableType.INTEGER_VALUE_RANGE) {
    return <ChatbotNodeIntegerRangeResponse id={id} showActions={showActions} variable={variable} />
  }

  if (variable?.type === EVariableType.MEDIA) {
    return (
      <ChatbotNodeMediaResponse
        id={id}
        showActions={showActions}
        isRequired={variable.isRequired !== false}
      />
    )
  }

  if (!showActions) {
    return (
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={!hasOutgoingEdge}
        style={{ width: '20px', height: '20px' }}
        className={
          isSourceOfSelectedEdge
            ? '!c-bg-primary-200 !c-border-2 !c-border-primary-500'
            : '!c-bg-white !c-border !c-border-black'
        }
      />
    )
  }

  return (
    <>
      {!isFirstNode && (
        <div className="c-absolute c-top-[calc(100%-14px)] c-left-12 c-flex c-justify-center c-pb-2">
          <DeletingNodeButton onClick={handleDeleteNode} />
        </div>
      )}

      <div className="c-absolute c-top-[calc(100%-14px)] c-left-1/2 c-translate-x-[-50%] c-flex c-justify-center c-pb-2">
        <ConnectingNodeButton
          isConnectable={!hasOutgoingEdge}
          isPartOfSelectedEdge={isSourceOfSelectedEdge}
        />
      </div>

      {!hasOutgoingEdge && (
        <div className="c-absolute c-top-[calc(100%-14px)] c-right-12 c-flex c-justify-center c-pb-2">
          <AddingNodeButton onClick={handleAddNode} />
        </div>
      )}
    </>
  )
}
